import type { SVGProps } from "react";
const SenecPictogramCarrierPortal = (props: Pick<SVGProps<SVGSVGElement>, "color">) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21 15C21 13.3431 22.3431 12 24 12C25.6569 12 27 13.3431 27 15C27 16.6569 25.6569 18 24 18C22.3431 18 21 16.6569 21 15ZM24 14C23.4477 14 23 14.4477 23 15C23 15.5523 23.4477 16 24 16C24.5523 16 25 15.5523 25 15C25 14.4477 24.5523 14 24 14Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15 17C15 12.0294 19.0294 8 24 8C28.9706 8 33 12.0294 33 17C33 21.9706 28.9706 26 24 26C19.0294 26 15 21.9706 15 17ZM24 10C20.134 10 17 13.134 17 17C17 19.0709 17.8993 20.9318 19.3287 22.2134C20.0478 20.3343 21.8681 19 24 19C26.1319 19 27.9522 20.3343 28.6713 22.2134C30.1007 20.9318 31 19.0709 31 17C31 13.134 27.866 10 24 10ZM24 24C22.9534 24 21.9604 23.7703 21.0687 23.3586C21.3625 22.0099 22.5633 21 24 21C25.4367 21 26.6375 22.0099 26.9313 23.3586C26.0396 23.7703 25.0466 24 24 24Z"
            fill="currentColor"
        />
        <path
            d="M17 28C16.4477 28 16 28.4477 16 29C16 29.5523 16.4477 30 17 30H31C31.5523 30 32 29.5523 32 29C32 28.4477 31.5523 28 31 28H17Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11 4H37V15H39C40.6569 15 42 16.3431 42 18V35C42 36.6569 40.6569 38 39 38H29.8685L33.8685 44H14.1315L18.1315 38H9C7.34315 38 6 36.6569 6 35V30C6 29.4477 6.44772 29 7 29C7.55228 29 8 29.4477 8 30V32H11V17H9C8.44772 17 8 17.4477 8 18V25C8 25.5523 7.55228 26 7 26C6.44772 26 6 25.5523 6 25V18C6 16.3431 7.34315 15 9 15H11V4ZM13 32H35V6H13V32ZM37 32H40V18C40 17.4477 39.5523 17 39 17H37V32ZM40 34H8V35C8 35.5523 8.44772 36 9 36H39C39.5523 36 40 35.5523 40 35V34ZM20.5352 38L17.8685 42H30.1315L27.4648 38H20.5352Z"
            fill="currentColor"
        />
    </svg>
);
export default SenecPictogramCarrierPortal;
